var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.showOverlay)?_c('div',[_c('iris-lottie-animation',{attrs:{"id":"loading-icon","animation-u-r-l":'https://assets.orb.alkamitech.com/staging/animations/Circle-Indeterminate-24.json',"alt":_vm.params.loadingAria,"height":40,"width":40,"is-looping":true,"speed":1,"is-aria-hidden":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }